var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, observable, computed } from "mobx";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
export class AggregatesIncidentsBlockState {
    constructor(provider) {
        this.provider = provider;
        this.latestIncident = {};
        this.incidents = [];
        this.firstLoad = true;
        this.shouldAnimateLatestIncident = false;
        this.shouldAnimateAllIncidents = false;
        this.latestIncidentAnimConfig = {
            timeout: {},
            duration: 2100,
            style: "rj-incidents-latest-animation"
        };
        this.allIncidentsAnimConfig = {
            timeout: {},
            duration: 800,
            style: "rj-incidents-all-animation"
        };
        this.latestIncidentClass = "";
        this.allIncidentsClass = "";
    }
    activate() {
        this.provider.on(InternalMessageBusChannels.aggregatedEvents.incident.update, this.updateIncidents);
        this.provider.emit(InternalMessageBusChannels.aggregatedEvents.incident.request);
        // TODO case when no incidents are returned
    }
    deactivate() {
        this.provider.off(InternalMessageBusChannels.aggregatedEvents.incident.update, this.updateIncidents);
        this.clearData();
        clearTimeout(this.latestIncidentAnimConfig.timeout);
        clearTimeout(this.allIncidentsAnimConfig.timeout);
    }
    updateIncidents(message) {
        if (message.data[0] && message.data[0].incidents[0]) {
            this.firstLoad = !this.isDataLoaded;
            this.shouldAnimateLatestIncident = this.latestIncident.id !== message.data[0].incidents[0].id;
            this.shouldAnimateAllIncidents = this.incidents.length < message.data[0].incidents.length - 1;
            this.latestIncident = message.data[0].incidents[0];
            this.incidents = message.data[0].incidents.slice(1);
            this.evaluateDataForAnimations();
        }
    }
    evaluateDataForAnimations() {
        this.shouldAnimateLatestIncident
            && this.latestIncident.minute < 1
            && this.startLatestIncidentAnimation();
        !this.firstLoad
            && this.shouldAnimateAllIncidents
            && this.incidents.length > 0
            && this.startAllIncidentsAnimation();
    }
    startLatestIncidentAnimation() {
        clearTimeout(this.latestIncidentAnimConfig.timeout);
        this.latestIncidentClass = this.latestIncidentAnimConfig.style;
        this.latestIncidentAnimConfig.timeout = setTimeout(this.removeLatestIncidentClass, this.latestIncidentAnimConfig.duration);
    }
    startAllIncidentsAnimation() {
        clearTimeout(this.allIncidentsAnimConfig.timeout);
        this.allIncidentsClass = this.allIncidentsAnimConfig.style;
        this.allIncidentsAnimConfig.timeout = setTimeout(this.removeAllIncidentsClass, this.allIncidentsAnimConfig.duration);
    }
    removeLatestIncidentClass() {
        this.latestIncidentClass = "";
    }
    removeAllIncidentsClass() {
        this.allIncidentsClass = "";
    }
    clearData() {
        this.latestIncident = {};
        this.incidents = [];
        this.firstLoad = true;
        this.shouldAnimateLatestIncident = false;
        this.shouldAnimateAllIncidents = false;
        this.removeLatestIncidentClass();
        this.removeAllIncidentsClass();
    }
    get isDataLoaded() {
        return this.latestIncident && this.latestIncident.id !== undefined;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AggregatesIncidentsBlockState.prototype, "latestIncident", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AggregatesIncidentsBlockState.prototype, "incidents", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AggregatesIncidentsBlockState.prototype, "latestIncidentClass", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], AggregatesIncidentsBlockState.prototype, "allIncidentsClass", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AggregatesIncidentsBlockState.prototype, "updateIncidents", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AggregatesIncidentsBlockState.prototype, "startLatestIncidentAnimation", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AggregatesIncidentsBlockState.prototype, "startAllIncidentsAnimation", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AggregatesIncidentsBlockState.prototype, "removeLatestIncidentClass", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AggregatesIncidentsBlockState.prototype, "removeAllIncidentsClass", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AggregatesIncidentsBlockState.prototype, "clearData", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], AggregatesIncidentsBlockState.prototype, "isDataLoaded", null);
//# sourceMappingURL=AggregatesIncidentsBlockState.js.map